import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigation_select_channel } from './../../../redux/reducers/navigationSlice';
import FormatText from '../../../helpers/FormatTitle';
import NavCollection from './NavCollection';
import { FrPickerContainer, FrPickerChannel, FrPickerCollection, FrPickerCollectionNumbers } from './NavChannel.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { COLOR } from '../../../theme/constants';

function mapStateToProps(state, ownProps) {
   return {
      SelectedChannel: state.navigation.selectedChannel,
      SelectedGeography: state.navigation.selectedGeography
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      selectChannel: (channel, isMobile) => {
         const params = {
            channel: channel,
            isMobile: isMobile
         };

         dispatch(navigation_select_channel(params));
      }
   };
};

class NavChannel extends Component<
   {
      isMobile: boolean;
      channelTitle: string;
      channelList: any[];
      active: boolean;
      selectChannel: any;
      SelectedChannel: string;
      SelectedGeography: string;
   },
   {}
> {
   constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
   }

   private onClick() {
      this.props.selectChannel(this.props.channelTitle, this.props.isMobile);
   }

   public render() {
      const { channelTitle, channelList, SelectedChannel, SelectedGeography } = this.props;

      const collectionLinks = channelList.map((collection, index) => (
         <NavCollection
            key={index}
            CollectionName=''
            CollectionType=''
            SelectedTemplateId='59e8edccbfce890eb411ef5b'
            name={collection.Name}
            channelTitle={channelTitle}
            id={collection.Id}
            templateid={collection.TId}
         />
      ));

      const channelContainerStyles = () => {
         const isActive = SelectedChannel === channelTitle ? 'active' : '';
         return `${isActive}`;
      };

      return (
         <FrPickerContainer>
            <FrPickerChannel
               className={channelContainerStyles()}
               data-analytics={`Forecasts-Navigation-${FormatText(SelectedGeography)}-${FormatText(channelTitle)}`}
               onClick={this.onClick}
            >
               <FontAwesomeIcon icon={channelContainerStyles() === 'active' ? faChevronUp : faChevronDown} width={10} color={COLOR.BLUE} />
               {channelTitle}
            </FrPickerChannel>
            <FrPickerCollection className={channelContainerStyles()}>
               <FrPickerCollectionNumbers className={channelContainerStyles()}>{collectionLinks}</FrPickerCollectionNumbers>
            </FrPickerCollection>
         </FrPickerContainer>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavChannel);
